module.exports = __webpack_public_path__ + "media/goforajourney/img/our-passion-07d784f974aaede9dcaf883bf764b31c.jpg";